/* Lisalva 22/10 (g) — botão × das linhas do carrinho (gaveta e página /cart).
   O link já remove sem JS (product.url_to_remove). Aqui usamos o mecanismo do próprio tema:
   quantidade da linha a 0 + evento "change" no .js-qty__num -> /cart/change.js, o tema volta
   a desenhar o carrinho, atualiza totais e o contador. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lis-cart-remove');
    if (!btn) return;
    var item = btn.closest('.cart__item');
    var input = item && item.querySelector('.js-qty__num');
    if (!input) return; /* sem campo de quantidade: deixa o link fazer a remoção */
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    item.classList.add('lis-cart-removing');
    input.value = 0;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  /* role="button" num <a>: também com a tecla Espaço */
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('.lis-cart-remove');
    if (btn) { e.preventDefault(); btn.click(); }
  });
})();
